import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMissingBooking = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "62px",
	height: "67px",
	viewBox: "0 0 62 67",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("title", { children: "Missing" }),
		/* @__PURE__ */ _jsx("desc", { children: "Created with Sketch." }),
		/* @__PURE__ */ _jsxs("g", {
			id: "Missing",
			stroke: "none",
			strokeWidth: 1,
			fill: "none",
			fillRule: "evenodd",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M61.5614035,62.8888889 L55.7309942,57.0584795 C55.4678363,56.7953216 55.1111111,56.6491228 54.7368421,56.6491228 L53.7836257,56.6491228 C55.3976608,54.5847953 56.3567251,51.9883041 56.3567251,49.1637427 C56.3567251,42.4444444 50.9122807,37 44.1929825,37 C37.4736842,37 32.0292398,42.4444444 32.0292398,49.1637427 C32.0292398,55.8830409 37.4736842,61.3274854 44.1929825,61.3274854 C47.0175439,61.3274854 49.6140351,60.3684211 51.6783626,58.754386 L51.6783626,59.7076023 C51.6783626,60.0818713 51.8245614,60.4385965 52.0877193,60.7017544 L57.9181287,66.5321637 C58.4678363,67.0818713 59.3567251,67.0818713 59.9005848,66.5321637 L61.5555556,64.877193 C62.1052632,64.3274854 62.1052632,63.4385965 61.5614035,62.8888889 Z",
					id: "Path",
					fill: "#3284DE"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M44.1929825,56.6491228 C40.0584795,56.6491228 36.7076023,53.3040936 36.7076023,49.1637427 C36.7076023,45.0292398 40.0526316,41.6783626 44.1929825,41.6783626 C48.3274854,41.6783626 51.6783626,45.0233918 51.6783626,49.1637427 C51.6783626,53.2982456 48.3333333,56.6491228 44.1929825,56.6491228 Z",
					id: "Path",
					fill: "#FFFFFF"
				}),
				/* @__PURE__ */ _jsx("circle", {
					id: "Oval-Copy-2",
					fill: "#E2EDF7",
					cx: 4.5,
					cy: 4.98242188,
					r: 4.5
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M16,41.4824219 C20.418278,41.4824219 24,37.9006999 24,33.4824219 C24,29.0641439 20.418278,25.4824219 16,25.4824219 C11.581722,25.4824219 8,29.0641439 8,33.4824219 C8,37.9006999 11.581722,41.4824219 16,41.4824219 Z M16,39.4824219 C12.6862915,39.4824219 10,36.7961304 10,33.4824219 C10,30.1687134 12.6862915,27.4824219 16,27.4824219 C19.3137085,27.4824219 22,30.1687134 22,33.4824219 C22,36.7961304 19.3137085,39.4824219 16,39.4824219 Z",
					id: "Oval",
					fill: "#2378CD",
					fillRule: "nonzero"
				}),
				/* @__PURE__ */ _jsx("rect", {
					id: "Rectangle-Copy",
					fill: "#3284DE",
					x: 36,
					y: 16.4824219,
					width: 25,
					height: 8,
					rx: 4
				})
			]
		})
	]
});
export default SvgMissingBooking;
